import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dialogTitle: {
    color: theme.palette.blue_300.main,
    fontSize: '20px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main
  },
  dialogContent: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end'
  },
  dialogActions: {
    padding: '18px 22px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main
  },
  buttonContact: {
    color: theme.palette.white_100.main,
    backgroundColor: theme.palette.blue_300.main,
    borderRadius: 8,
    width: '43px',
    height: '43px',
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main
    }
  },
  inputAutocomplete: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      fontSize: '1rem',
      fontFamily: 'Inter, sans-serif',
      fontWeight: '400',
      lineWeight: '1'
    }
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '1rem'
  },
  radio: {
    '&.MuiRadio-root': {
      color: theme.palette.blue_300.main,
      padding: 0,
      marginRight: 4
    },
    '& .MuiSvgIcon-root': {
      fontSize: 18
    },
    '&.Mui-checked': {
      color: theme.palette.blue_300.main
    }
  },

  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginLeft: '8px'
  },
  statusDotOnline: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: theme.palette.green_200.main,
    display: 'inline-block'
  },
  statusDotOffline: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: theme.palette.red_100.main,
    display: 'inline-block'
  },
  userStatus: {
    fontSize: '.775rem'
  },

  dialogWarning: {
    '& .MuiDialog-paper': {
      width: '400px',
      maxWidth: '400px',
      borderRadius: '8px'
    }
  },
  warningContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    '& svg': {
      color: theme.palette.red_100.main
    }
  },
  dialogWarningTitle: {
    '& .MuiDialogTitle-root': {
      padding: '0 !important'
    }
  },
  warningTitle: {
    fontSize: '1.6rem',
    fontWeight: '600',
    color: theme.palette.red_100.main
  },
  warningDescription: {
    fontWeight: '400',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  inputWrapperPhone: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    // '& .MuiInputBase-root': {
    //   flex: 0
    // }
  }
}))
